import { render } from "./ArticleAll.vue?vue&type=template&id=c4e7ebe0&scoped=true"
import script from "./ArticleAll.vue?vue&type=script&lang=js"
export * from "./ArticleAll.vue?vue&type=script&lang=js"

import "./ArticleAll.vue?vue&type=style&index=0&id=c4e7ebe0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e7ebe0"]])

export default __exports__